import HttpClient from './utils/HttpClient';
import APIError from '../errors/APIError';

import { IComplement } from '../models';

class ComplementsService {
  private httpClient = HttpClient;

  public async listComplementsByProductId(
    companyId: number,
    productId: number,
  ): Promise<IComplement[]> {
    try {
      const complements = await this.httpClient.get(
        `/companies/${companyId}/products/${productId}/complements`,
      );

      return complements.data;
    } catch (error) {
      const parsedError = error as any;

      let errorMessage = parsedError?.response?.data?.message;

      if (!errorMessage) {
        errorMessage = 'Erro ao tentar listar os complementos';
      }

      throw new APIError(errorMessage);
    }
  }

  public async sortComplements(
    companyId: number,
    productId: number,
    complements: Pick<IComplement, 'id' | 'order'>[],
  ): Promise<IComplement[]> {
    try {
      const sortedComplements = await this.httpClient.patch(
        `/companies/${companyId}/products/${productId}/complements/sort`,
        { complements },
      );

      return sortedComplements.data;
    } catch (error) {
      const parsedError = error as any;

      let errorMessage = parsedError?.response?.data?.message;

      if (!errorMessage) {
        errorMessage = 'Erro ao tentar reordenar os complementos';
      }

      throw new APIError(errorMessage);
    }
  }

  public async deleteComplement(
    companyId: number,
    complementId: number,
  ): Promise<void> {
    try {
      await this.httpClient.delete(
        `/companies/${companyId}/complements/${complementId}`,
      );
    } catch (error) {
      const parsedError = error as any;

      let errorMessage = parsedError?.response?.data?.message;

      if (!errorMessage) {
        errorMessage = 'Erro ao tentar excluir o complemento';
      }

      throw new APIError(errorMessage);
    }
  }
}

export default new ComplementsService();
